<template>
  <div>
    <!-- <v-progress-circular v-if="loading" indeterminate /> -->
    <v-select
      :items="ScopeOptions"
      :readonly="readonly"
      :loading="loading"
      label="Scope of Practice"
      :value="value"
      item-value="valueid"
      item-text="value"
      @change="$emit('change', $event.scopeofpracticeid)"
      :error-messages="errors"
      single-line
      return-object
    />
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "ScopeSelect",
  data() {
    return {
      loading: false,
      feeTypes: {},
      errors: []
    };
  },
  methods: {
    handleError(e) {
      this.errors.push(e.message);
    }
  },
  computed: {
    ...mapGetters({ lookup: "lookup" }),
    ScopeOptions() {
      return this.lookup("ScopesOfPractice");
    }
  },
  props: {
    value: Number,
    personid: {
      required: false,
      default: null,
      type: Number
    },
    readonly: Boolean
  }
};
</script>
